var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.17702H13V9.14625H11V7.17702ZM11 11.1694H13V17.077H11V14.1463V11.1694ZM12 2.00012C6 2.00012 2 6.71889 2 12.154C2 17.589 6.48 22.0001 12 22.0001C17.52 22.0001 22 17.589 22 12.154C22 6.71889 18 2.00012 12 2.00012ZM12 20.5001C7.3125 20.5001 3.5 16.8078 3.5 12.154C3.5 7.50012 7 3.50012 12 3.50012C17 3.50012 20.5 7.40637 20.5 12.154C20.5 16.4961 16.6875 20.5001 12 20.5001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.45b84dacb6beb2197c53d33b3241b682.svg";
export { ForwardRef as ReactComponent };